import { store } from '@store/index';
import { logout } from '@store/slices/authSlice';
import { AUTH_STORAGE_KEYS } from '../config/auth';

/**
 * Canonical client-side session teardown: clear Redux auth state, remove every
 * persisted auth key, and redirect to /login.
 *
 * Called by authService and by the RTK Query base query (lazily imported there
 * to avoid a circular dependency). Timer cleanup is authService-specific and
 * stays there.
 */
export const clearSession = () => {
  store.dispatch(logout());
  Object.values(AUTH_STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));

  // Avoid a redirect loop when a 401 happens on the login page itself
  // (e.g. a wrong-password attempt).
  if (!window.location.pathname.includes('/login')) {
    window.location.href = '/login';
  }
};
